import React from 'react';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';

const TenantDetail = ({ form, handleChange }) => {
  return (
    <Row>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Tenant Name" className="mb-3">
          <Form.Control
            required
            className="input"
            name="tenantName"
            value={form.tenantName}
            onChange={handleChange}
            type="text"
            placeholder="Tenant Name"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Tenant Email" className="mb-3">
          <Form.Control
            className="input"
            name="tenantEmail"
            value={form.tenantEmail}
            onChange={handleChange}
            type="email"
            placeholder="Tenant Email"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Tenant Phone No" className="mb-3">
          <Form.Control
            className="input"
            name="tenantPhoneNo"
            value={form.tenantPhoneNo}
            onChange={handleChange}
            type="text"
            placeholder="Tenant Phone No"
          />
        </FloatingLabel>
      </Col>
      <Col xs={12}>
        <FloatingLabel controlId="floatingInput" label="Tenant Address" className="mb-3">
          <Form.Control
            as="textarea"
            className="input"
            name="tenantAddress"
            value={form.tenantAddress}
            onChange={handleChange}
            type="text"
            placeholder="Tenant Address"
            style={{ height: '80px' }} 
          />
        </FloatingLabel>
      </Col>
    </Row>
  );
};

export default TenantDetail;
